import { Controller } from '../utils/controller';
export default class extends Controller {
  static targets = ['arrow', 'content', 'plus', 'minus', 'collapse'];
  static requiredTargets = [];

  static classes = ['hide', 'rotate'];
  static requiredClasses = [];

  // TARGETS
  declare arrowTarget: HTMLElement;
  declare plusTarget: HTMLElement;
  declare minusTarget: HTMLElement;
  declare contentTarget: HTMLElement;
  declare hasArrowTarget: boolean;
  declare hasContentTarget: boolean;
  declare hasCollapseTarget: boolean;

  // CLASSES
  declare hideClasses: string[];
  declare rotateClass: string;

  collapse() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.add(...this.hideClasses);
    }
    if (this.hasArrowTarget) {
      this.arrowTarget.classList.remove(this.rotateClass);
    }
    if (this.hasCollapseTarget) {
      this.plusTarget.classList.remove('hidden');
      this.minusTarget.classList.add('hidden');
    }
  }

  toggleAccordion(event) {
    event.preventDefault();
    if (this.hasContentTarget) {
      this.hideClasses.forEach((classname) => {
        this.contentTarget.classList.toggle(classname);
      });
    }
    if (this.hasArrowTarget) {
      this.arrowTarget?.classList.toggle(this.rotateClass);
    }
    if (this.hasCollapseTarget) {
      this.plusTarget.classList.toggle('hidden');
      this.minusTarget.classList.toggle('hidden');
    }
    const isAccordionOpen = this.contentTarget.classList.contains('is-open');
    this.setTabIndexForLinks(isAccordionOpen);
  }

  setTabIndexForLinks(isAccordionOpen: boolean) {
    const links = this.contentTarget.querySelectorAll('a, button');
    links.forEach((link) => {
      if (isAccordionOpen) {
        link.setAttribute('tabindex', '0');
      } else {
        link.setAttribute('tabindex', '-1');
      }
    });
  }
}
